import FacebookIconPath from '@assets/images/common/icon/sns/facebook.svg';
import LineIconPath from '@assets/images/common/icon/sns/line.svg';
import XIconPath from '@assets/images/common/icon/sns/x.svg';
import React from 'react';

type SnsShareButtonsProps = {
  url: string;
  title: string;
  tags: string[];
  disabled?: boolean;
  variant?: 'full' | 'compact';
};

export const SnsShareButtons: React.FC<SnsShareButtonsProps> = ({
  url,
  title,
  tags,
  disabled = false,
  variant = 'full',
}) => {
  const encodedUrl = encodeURIComponent(url);

  const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;

  const lineShareUrl = `https://social-plugins.line.me/lineit/share?url=${encodedUrl}&text=${encodeURIComponent(title)}`;

  const hashtagsText = tags
    .slice(0, 10)
    .map((tag) => `#${tag}`)
    .join(' ');
  const tweetTextParts = [url, title, hashtagsText];
  const encodedTweetText = encodeURIComponent(tweetTextParts.filter((part) => part).join('\n'));
  const xShareUrl = `https://twitter.com/intent/tweet?text=${encodedTweetText}`;

  const containerClassName = disabled ? 'share-container disabled' : 'share-container';

  const buttons = (
    <div className={`share-buttons`}>
      <a
        href={disabled ? undefined : facebookShareUrl}
        target='_blank'
        rel='noopener noreferrer'
        aria-label='Facebookでシェア'
      >
        <img
          src={FacebookIconPath}
          alt='Facebook'
        />
      </a>
      <a
        href={disabled ? undefined : xShareUrl}
        target='_blank'
        rel='noopener noreferrer'
        aria-label='Xでシェア'
      >
        <img
          src={XIconPath}
          alt='X'
        />
      </a>
      <a
        href={disabled ? undefined : lineShareUrl}
        target='_blank'
        rel='noopener noreferrer'
        aria-label='LINEでシェア'
      >
        <img
          src={LineIconPath}
          alt='LINE'
        />
      </a>
    </div>
  );

  if (variant === 'compact') {
    return buttons;
  }

  return (
    <div className={containerClassName}>
      <p className='share-title'>シェアする</p>
      {buttons}
    </div>
  );
};
